import { useAppContext } from "@qpr/client-api-base/context/AppCtxProvider";
import { usePeriod } from "backend/model/usePeriod";
import getValues from "backend/values";

import { useQuery } from "react-query";
import usePeriodLevels from "../model/usePeriodLevels";
import * as wf from "@qpr/client-api-workflow";

const useComments = (params: { id: string; period: string }) => {
  return useQuery(
    `data-comments-${params.id}-${params.period}`,
    () => {
      return wf.getComment({
        parentId: params.id,
        period: params.period || "latestforseries",
      });
    },
    {
      enabled: !!params.id && !!params.period,
      cacheTime: 10 * (60 * 1000),
      staleTime: 10 * (60 * 1000),
    }
  );
};

export default useComments;
